import React, { useState, useEffect } from 'react';
import { Navbar as BootstrapNavbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';
import '../../assets/styles/global.css';
import { IMAGES } from '../../assets/image';

const Navbar = () => {
  const [expanded, setExpanded] = useState(false);
  const [language, setLanguage] = useState('en');
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const [scriptError, setScriptError] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const hideApplyLink = location.pathname.toLowerCase().includes('/applicationform');

  useEffect(() => {
    const getCurrentLanguage = () => {
      try {
        const cookie = document.cookie
          .split('; ')
          .find(c => c.startsWith('googtrans='));
        if (cookie) {
          const lang = cookie.split('=')[1]?.split('/')[2];
          return lang === 'es' ? 'es' : 'en';
        }
      } catch (err) {
        console.error('Error reading language from cookie:', err);
      }
      return 'en';
    };
  
      

    // Set initial language from cookie or localStorage
    const detectedLang = getCurrentLanguage();
    setLanguage(detectedLang);
    localStorage.setItem('lang', detectedLang);
    console.log('Detected language:', detectedLang);
  
    // Initialize Google Translate once it's loaded
    const checkScript = setInterval(() => {
      if (window.google?.translate?.TranslateElement) {
        clearInterval(checkScript);
        setScriptLoaded(true);
        if (detectedLang !== 'en') {
          window.googleTranslateElementInit?.();
        }
      }
    }, 100);
  
    // Hide the default Google banner if present
    const hideBanner = setInterval(() => {
      const banner = document.querySelector('.goog-te-banner-frame');
      if (banner) {
        banner.style.display = 'none';
        document.body.style.top = '0px';
        clearInterval(hideBanner);
      }
    }, 100);
  
    return () => {
      clearInterval(checkScript);
      clearInterval(hideBanner);
    };
  }, []);
  
  const handleApplyNow = () => {
        localStorage.removeItem('current_guid');
        localStorage.removeItem('form_data');
        sessionStorage.clear();
        navigate('/ApplicationForm');
      };
      
  useEffect(() => {
    // Expose init function to global scope for Google's callback
    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement({
        pageLanguage: 'en',
        includedLanguages: 'en,es',
        layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
        autoDisplay: false,
      }, 'google_translate_element');
    };
  
    if (window.google?.translate?.TranslateElement && language !== 'en') {
      window.googleTranslateElementInit();
    }
  }, [language]);
  
  const deleteGoogleTranslateCookies = () => {
    const baseDomain = window.location.hostname;

    const domainVariants = [
      baseDomain,                        // test.salrefi.com
      '.' + baseDomain,                 // .test.salrefi.com
      baseDomain.replace(/^www\./, ''),// salrefi.com
      '.' + baseDomain.replace(/^www\./, ''), // .salrefi.com
      'salrefi.com',
      '.salrefi.com'
    ];

    domainVariants.forEach(domain => {
      document.cookie = `googtrans=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
      console.log(`Deleted googtrans cookie for domain: ${domain}`);
    });

    // Also delete without domain
    document.cookie = `googtrans=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
  };

  const handleLanguageChange = (e) => {
    const selectedLang = e.target.value;
    setLanguage(selectedLang);

    try {
      const googTransValue = selectedLang === 'en' ? '/en/en' : `/en/${selectedLang}`;
      console.log('Before:', document.cookie);
      deleteGoogleTranslateCookies();
      console.log('After:', document.cookie);
      //  Clear previous cookies first (both versions: with and without domain)
      document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}`;

      // Set new cookie for selected language
      document.cookie = `googtrans=${googTransValue}; path=/;`;
      document.cookie = `googtrans=${googTransValue}; path=/; domain=${window.location.hostname};`;

      // Optional: reinitialize the translate widget
      if (window.google?.translate?.TranslateElement) {
        new window.google.translate.TranslateElement({
          pageLanguage: 'en',
          includedLanguages: 'en,es',
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
          autoDisplay: false,
        }, 'google_translate_element');
      }

      // Reload page after small delay to apply changes
      setTimeout(() => {
        window.location.reload();
      }, 300);
    } catch (error) {
      console.error('Error switching language:', error);
    }
  };

  
  
 return (
  <BootstrapNavbar
    bg="light"
    expand="lg"
    fixed="top"
    expanded={expanded}
    onToggle={() => setExpanded(!expanded)}
    aria-label="Main navigation"
    className="navbar-custom"
  >
    <Container className="navbar-inner layout-container d-flex align-items-center">
      <BootstrapNavbar.Brand as={Link} to="https://nutmegstatefcu.org/" aria-label="Credit Union">
        <img src={IMAGES.Logo} alt="Credit Union Logo" className="navbar-logo" />
      </BootstrapNavbar.Brand>

      <BootstrapNavbar.Toggle aria-controls="navbarNav" />

      <BootstrapNavbar.Collapse id="navbarNav">
        <Nav className="ms-auto navbar-links" role="navigation">
          <Nav.Link
            className="nav-link"
            onClick={() => {
              if (location.pathname !== '/') {
                navigate('/#about'); 
              } else {
                const el = document.querySelector('#about');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }
            }}
          >
            About Us
          </Nav.Link>

          {!hideApplyLink && (
            <Nav.Link
              as={Link}
              to="/ApplicationForm" 
              className="nav-link"
              onClick={handleApplyNow}
            >
              Apply
            </Nav.Link>
          )}

          <Nav.Link
            className="nav-link"
            onClick={() => {
              if (location.pathname !== '/') {
                navigate('/#faq'); // Use navigate instead of window.location.href
              } else {
                const el = document.querySelector('#faq');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }
            }}
          >
            FAQs
          </Nav.Link>

          <div className="translate-container">
            {scriptError && (
              <span className="text-danger" style={{ marginRight: '10px' }}>
                Translation unavailable
              </span>
            )}
            <select
              value={language}
              onChange={handleLanguageChange}
              className="form-control translate-select"
              aria-label="Select Language"
              disabled={scriptError}
            >
              <option value="en">English</option>
              <option value="es">Español</option>
            </select>
            <div id="google_translate_element" style={{ display: 'none' }}></div>
          </div>
        </Nav>
      </BootstrapNavbar.Collapse>
    </Container>
  </BootstrapNavbar>
);
};

export default Navbar;